import { render, staticRenderFns } from "./AttributeNumberFilterSettings.vue?vue&type=template&id=3e1f9c8e&scoped=true"
import script from "./AttributeNumberFilterSettings.vue?vue&type=script&lang=ts"
export * from "./AttributeNumberFilterSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f9c8e",
  null
  
)

export default component.exports